// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqSuspensionTrainerSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqSuspensionTrainerSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none">
      <g clipPath="url(#clip0_513_61417)">
        <path
          d="M20 13.5V18.75C20 19.7446 19.6049 20.6984 18.9017 21.4017C18.1984 22.1049 17.2446 22.5 16.25 22.5C15.2554 22.5 14.3016 22.1049 13.5983 21.4017C12.8951 20.6984 12.5 19.7446 12.5 18.75V5.25C12.5 4.25544 12.1049 3.30161 11.4017 2.59835C10.6984 1.89509 9.74456 1.5 8.75 1.5C7.75544 1.5 6.80161 1.89509 6.09835 2.59835C5.39509 3.30161 5 4.25544 5 5.25V10.5"
          stroke={fill}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M6.875 19.5H3.125"
          stroke={fill}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M1.25 19.5V18L3.878 13.401C3.99104 13.2032 4.15436 13.0388 4.3514 12.9245C4.54844 12.8102 4.7722 12.75 5 12.75C5.2278 12.75 5.45156 12.8102 5.6486 12.9245C5.84564 13.0388 6.00896 13.2032 6.122 13.401L8.75 18V19.5"
          stroke={fill}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M18.125 4.5H21.875"
          stroke={fill}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M23.75 4.5V6L21.122 10.599C21.009 10.7968 20.8456 10.9612 20.6486 11.0755C20.4516 11.1898 20.2278 11.25 20 11.25C19.7722 11.25 19.5484 11.1898 19.3514 11.0755C19.1544 10.9612 18.991 10.7968 18.878 10.599L16.25 6V4.5"
          stroke={fill}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
}

export default EqSuspensionTrainerSVG;
